export const DIMENSION_MAX_WIDTH_MM = 2000;
export const DIMENSION_MAX_WIDTH_INCHES = 78.74;
export const DIMENSION_MIN_BAGS_HEIGHT_MM = 25.4;
export const DIMENSION_MIN_BAGS_HEIGHT_INCHES = 1;

export const DIMENSION_MIN_WIDTH_MM = 100;
export const DIMENSION_MIN_WIDTH_INCHES = 3.93701;

export const WEIGHT_MAX_KG = 1994;
export const WEIGHT_MAX_LB = 4400;
export const BAGS_WEIGHT_MAX_KG = 36.2874;
export const BAGS_WEIGHT_MAX_LB = 80;

export const PALLET_MAX_WIDTH_MM = 1500;
export const PALLET_MAX_WIDTH_INCHES = 59.05;

export const PALLET_MAX_HEIGHT_MM = 152.4;
export const PALLET_MAX_HEIGHT_INCHES = 6;

export const PALLET_MIN_WIDTH_MM = 609.6;
export const PALLET_MIN_WIDTH_INCHES = 24;

export const CONVERSION_RATE = 25.4;
/**
 * Conversion rate to convert the angle of inclination for boxes that are face to face
 */
export const CONVERSION_RATE_FACE2FACE = 35;
export const CONVERSION_RATE_KG_LBS = 2.205;

export const MAX_LOAD_HEIGHT_INCHES = 110;
export const MAX_LOAD_HEIGHT_MM = MAX_LOAD_HEIGHT_INCHES * CONVERSION_RATE;

// Max overhang in inches.
export const MAX_OVERHANG_INCHES = 6;
export const MAX_OVERHANG_MM = 6 * CONVERSION_RATE;
export const MAX_OVERLAP_INCHES = 8;
export const MAX_OVERLAP_MM = 8 * CONVERSION_RATE;
